<template>
  <div :class="size">
    <div class="item-type " :class="{'active': active}" @click="clicked">
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'item-type-component',
  props: {
    active: {},
    title: {},
    size: {default: "col-md-4"}
  },
  methods: {
    clicked() {
      this.$emit("clicked")
    }
  }
}
</script>
<style scoped>
.item-type {
  padding: 10px 20px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  border: solid #0f4c47 1px;
  color: #0f4c47;
  transition: .2s;
}

.item-type.active {
  background-color: #0f4c47;
  color: #ecfdf5;
}
</style>